import { render, staticRenderFns } from "./NotificationsExtra.vue?vue&type=template&id=50758552&"
import script from "./NotificationsExtra.vue?vue&type=script&lang=js&"
export * from "./NotificationsExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports